import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-84779af6")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " PDF Downloaded", -1)
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Need to change your design?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "You can edit and print your design as many times as you need.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Need help printing?")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " We can help you troubleshoot common label printing issues to get the perfect print! ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _createElementVNode("h1", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: "download",
              "aria-hidden": "true"
            }),
            _hoisted_2
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("p", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Edit your design ›")
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("p", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPrintingHelp && _ctx.openPrintingHelp(...args)))
            }, "Get help printing your labels ›")
          ])
        ])
      ], 2)
    ], 2)
  ]))
}